const getSitepass = () => {
  const cookies = document.cookie.split(';');
  let sitep = 'not found';
  cookies.forEach((element) => {
    if (element.match(/sitepass/i)) {
      element = element.split('=')[1];
      sitep = element;
    }
  });
  return sitep;
};

export default getSitepass;



// WEBPACK FOOTER //
// ./src/sitepass.js